/**
 * @generated SignedSource<<f8ae20c9ecd22489dc1e56329da7859b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTodoEditAddImageImageMutation$variables = {
  employeeId?: string | null;
  todoId: string;
};
export type useTodoEditAddImageImageMutation$data = {
  readonly todo: {
    readonly addImage: {
      readonly image: {
        readonly id: string;
      };
      readonly imageUploadUrl: string;
      readonly todo: {
        readonly images: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainMediaComponentMedia_todo">;
      };
    };
  } | null;
};
export type useTodoEditAddImageImageMutation = {
  response: useTodoEditAddImageImageMutation$data;
  variables: useTodoEditAddImageImageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "todoId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUploadUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTodoEditAddImageImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTodoAddImagePayload",
            "kind": "LinkedField",
            "name": "addImage",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "todo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TodoEditNewMainMediaComponentMedia_todo"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useTodoEditAddImageImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTodoAddImagePayload",
            "kind": "LinkedField",
            "name": "addImage",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "todo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "height",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "width",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "urlExpiresAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbhash",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canWrite",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrg",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "040815ce82e976237f402ad960202f01",
    "id": null,
    "metadata": {},
    "name": "useTodoEditAddImageImageMutation",
    "operationKind": "mutation",
    "text": "mutation useTodoEditAddImageImageMutation(\n  $todoId: ID!\n  $employeeId: ID\n) {\n  todo(todoId: $todoId, employeeId: $employeeId) {\n    addImage {\n      image {\n        id\n      }\n      imageUploadUrl\n      todo {\n        images {\n          id\n        }\n        ...TodoEditNewMainMediaComponentMedia_todo\n        id\n      }\n    }\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment LinkedContentInput_images on Image {\n  ...LinkedContent_images\n}\n\nfragment LinkedContent_images on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  ...LinkedImageItem_image\n}\n\nfragment LinkedImageItem_image on Image {\n  id\n  ...Image_image\n}\n\nfragment TodoEditNewMainMediaComponentMedia_todo on Todo {\n  id\n  canWrite\n  isOrg\n  images {\n    id\n    sizes {\n      height\n      width\n      id\n    }\n    ...LinkedContentInput_images\n    ...Image_image\n  }\n}\n"
  }
};
})();

(node as any).hash = "6bff8fc5eac0209c197682c65c4873c3";

export default node;
